module.exports = __webpack_public_path__ + "1f905d23af144bc76e488f00d516de2e.svg";